import React from 'react';

import { SvenStyle, SvenImg } from 'styles/pages/sven.styles';

export const Sven = () => {
    return (
        <SvenStyle style={{ color: 'white' }}>
            <SvenImg src="https://s3.eu-central-1.amazonaws.com/totems3/img/sven.jpg" />
        </SvenStyle>
    );
};
